import 'firebase/firestore';

// import firebase from 'firebase';
import * as firebase from 'firebase';

const config = {
  apiKey: "AIzaSyCpA_Grq2EQ_B26Z8YEme4avMtti6GCLMM",
  authDomain: "custom-wine.firebaseapp.com",
  projectId: "custom-wine",
  storageBucket: "custom-wine.appspot.com",
  messagingSenderId: "966407654501",
  appId: "1:966407654501:web:7ebc81c30109b5f1ea0a8c",
  measurementId: "G-XCG5RYXN9V"
};
firebase.initializeApp(config);
const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

export { firebase, db, auth };
